import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { useReveal } from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";

const Blog = () => {
  const { blogPosts } = useContent();
  const r = useReveal();
  const [featured, ...rest] = blogPosts;
  return (
    <main className="pt-[76px]">
      <Seo
        title="Journal"
        description="News, insight and craft from Fletcher & Stone — thoughts on traditional building, heritage restoration, extensions and fine joinery across London, The Home Counties and The Cotswolds."
        path="/blog"
      />
      <PageHero
        eyebrow="Journal"
        title="News, insight & craft"
        subtitle="Thoughts on traditional building, heritage restoration and life on our sites across London, The Home Counties and The Cotswolds."
        image="https://images.unsplash.com/photo-1688584270451-a0e8fe6df4e6"
      />

      <section className="max-w-[1240px] mx-auto px-5 md:px-8 py-20 md:py-28">
        {/* Featured */}
        <Link to={`/blog/${featured.id}`} ref={r.ref} data-testid="blog-featured" className={`group grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-20 ${r.className}`}>
          <div className="overflow-hidden h-[340px] md:h-[460px]">
            <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
          </div>
          <div>
            <div className="flex items-center gap-4 mb-5">
              <span className="font-body uppercase tracking-[0.16em] text-[11px] text-[#94664f]">{featured.category}</span>
              <span className="overline">{featured.date}</span>
            </div>
            <h2 className="section-title text-[32px] md:text-[42px] mb-5">{featured.title}</h2>
            <p className="font-body text-[15.5px] leading-[2] text-[#5b564d] mb-7">{featured.excerpt}</p>
            <span className="inline-flex items-center gap-2 text-[#23211e] font-body uppercase tracking-[0.16em] text-[12px] group-hover:text-[#94664f] transition-colors">
              Read article <ArrowUpRight size={15} />
            </span>
          </div>
        </Link>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14 border-t border-[#eae5db] pt-16">
          {rest.map((post) => (
            <Link to={`/blog/${post.id}`} key={post.id} data-testid="blog-card" className="group">
              <div className="overflow-hidden h-[240px] mb-6">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
              </div>
              <div className="flex items-center gap-4 mb-3">
                <span className="font-body uppercase tracking-[0.16em] text-[11px] text-[#94664f]">{post.category}</span>
                <span className="overline">{post.date}</span>
              </div>
              <h3 className="font-display text-[25px] text-[#23211e] leading-[1.25] mb-3 group-hover:text-[#94664f] transition-colors">{post.title}</h3>
              <p className="font-body text-[14px] leading-[1.9] text-[#6b665d]">{post.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Blog;
